import type { CardFeatures } from '../../CardFeatures';
import { accountLinkage } from '../account-linkage/CZ';
import { dynamicCurrencyConversion } from '../card-dynamic-currency-conversion/CZ';
import { cardImage } from '../card-image/CZ';
import { cardInsurance } from '../card-insurance/CZ';
import { limitsChange } from '../card-limits-change/CZ';
import { cardLimitsFocusPage } from '../card-limits-focus-page/CZ';
import { limits } from '../card-limits/combined-limits/CZ';
import { permanentLimitsLegacy } from '../card-limits/permanent-limits-legacy/CZ';
import { permanentLimits } from '../card-limits/permanent-limits/CZ';
import { temporaryLimits } from '../card-limits/temporary-limits/CZ';
import { cardLockAndReplace } from '../card-lock-and-replace/CZ';
import { cardLock } from '../card-lock/CZ';
import { prepaidCardInfo } from '../card-prepaid-info/CZ';
import {
    card3DSecureCode,
    card3DSecureCodeEncryption,
} from '../card-services/card-3d-secure-code/CZ';
import { automaticCardReplacement } from '../card-services/card-automatic-replacement/CZ';
import { cardCancellation } from '../card-services/card-cancellation/CZ';
import { cardDelivery } from '../card-services/card-delivery/CZ';
import { changeCardDesign } from '../card-services/card-design-change/CZ';
import { cardLoyaltyProgramExternal } from '../card-services/card-loyalty-external/CZ';
import { supplementaryCardInstallments } from '../card-services/supplementary-card-installments/CZ';
import { cardMigrationExternal } from '../card-services/card-migration-external/CZ';
import { creditCardReissueExternal } from '../card-services/card-reissue-external/CZ';
import { cardReissue } from '../card-services/card-reissue/CZ';
import { orderReplacementCard } from '../card-services/card-replacement/CZ';
import { cardDetails, cardDetailsEncryption } from '../card-services/card-secured-details/CZ';
import { changeCardDelivery } from '../card-services/delivery-management-v2/CZ';
import { displayPin, displayPinEncryption } from '../card-services/display-pin/CZ';
import { changePinDelivery } from '../card-services/pin-delivery-change/CZ';
import { pinDeliveryFromCardDelivery } from '../card-services/pin-delivery-from-card-delivery/CZ';
import { pinDelivery } from '../card-services/pin-delivery/CZ';
import { reprintPinFocusPage } from '../card-services/reprint-pin-focus-page/CZ';
import { reprintPin } from '../card-services/reprint-pin/CZ';
import { cardTracking } from '../card-tracking/CZ';
import { cardUnlock } from '../card-unlock/CZ';
import { bankCardLimitChange } from '../cards-bank/card-limit-changes/CZ';
import { cardLimitInfo } from '../cards-bank/card-limit-info/CZ';
import { cardReplacement } from '../cards-bank/card-replacement/CZ';
import { geoControl } from '../cards-bank/geo-control/CZ';
import { linkedAccounts } from '../cards-bank/linked-accounts/CZ';
import { microCardActivation } from '../cards-bank/micro-card-activation/CZ';
import { microSticker } from '../cards-bank/micro-sticker/CZ';
import { cardServices } from '../cards-credit/additional-services/CZ';
import { cardFees } from '../cards-credit/card-fees/CZ';
import { creditCardLimitChange } from '../cards-credit/card-limit-change/CZ';
import { creditCardLimitInfo } from '../cards-credit/card-limit-info/CZ';
import { creditCardMeter } from '../cards-credit/card-meter/CZ';
import { creditCardDirectDebit } from '../cards-credit/direct-debit/CZ';
import { creditCardPayUp } from '../cards-credit/pay-up/CZ';
import { autoRepayment } from '../cards-credit/repayment/CZ';
import { creditCardStatements } from '../cards-credit/statements/CZ';
import { contactlessPayments } from '../contactless-payments/CZ';
import { expirationTime } from '../expiration-time/CZ';
import { installmentsActivation } from '../installments-activation/CZ';
import { installments } from '../installments/CZ';
import { temporaryDeactivation } from '../temporary-deactivation/CZ';
import { topUp } from '../top-up/CZ';
import { upcomingInstallments } from '../upcoming-installments/CZ';

export const cards: CardFeatures = {
    accountLinkage,
    autoRepayment,
    bankCardLimitChange,
    card3DSecureCode,
    card3DSecureCodeEncryption,
    cardCancellation,
    cardDelivery,
    cardDetails,
    cardDetailsEncryption,
    cardFees,
    cardInsurance,
    cardLimitInfo,
    cardLock,
    cardLockAndReplace,
    cardLoyaltyProgramExternal,
    cardMigrationExternal,
    cardReissue,
    cardReplacement,
    cardServices,
    cardTracking,
    supplementaryCardInstallments,
    cardUnlock,
    changeCardDesign,
    contactlessPayments,
    creditCardLimitChange,
    creditCardLimitInfo,
    creditCardReissueExternal,
    creditCardStatements,
    displayPin,
    displayPinEncryption,
    dynamicCurrencyConversion,
    expirationTime,
    geoControl,
    installments,
    installmentsActivation,
    upcomingInstallments,
    limits,
    limitsChange,
    linkedAccounts,
    microCardActivation,
    microSticker,
    permanentLimits,
    permanentLimitsLegacy,
    pinDelivery,
    pinDeliveryFromCardDelivery,
    prepaidCardInfo,
    reprintPin,
    temporaryDeactivation,
    temporaryLimits,
    topUp,
    cardLimitsFocusPage,
    creditCardPayUp,
    reprintPinFocusPage,
    automaticCardReplacement,
    changePinDelivery,
    changeCardDelivery,
    creditCardDirectDebit,
    orderReplacementCard,
    creditCardMeter,
    cardImage,
    relyOnPAPIDataForCards: {
        enabled: false,
    },
    redesignedCardContentBox: {
        enabled: true,
    },
    redesignedDebitCardContentBox: {
        enabled: true,
    },
    additionalCreditCards: {
        enabled: false,
    },
    cardsTicketing: {
        enabled: true,
    },
    nativeCardOrder: {
        enabled: false,
    },

    nativeCardReplacement: {
        enabled: false,
    },
};
